import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { MemberRoutes } from "./memberRoutes";
import { DashboardRoutes } from "./dashboardRoutes";
import { HostRoutes } from "./hostRoutes";
import { useContext, useEffect, useState } from "react";
import { getMemberProfileQuery } from "redux/features/memberSlice/memberGql";
import { useDispatch, useSelector } from "react-redux";
import { setMemberDetails } from "redux/features/memberSlice/memberSlice";
import { useQuery } from "@apollo/client";
import Loader from "shared/Components/loader";
import { setRefresh } from "redux/globalSlice";
import { ROLE } from "helper/utility";
import {
  OriginalRoleDisptachContext,
  RoleContext,
  RoleDispatchContext,
} from "context/RoleContext";
import { SuperAdminRoutes } from "./superAdminRoutes";
import { setHostProfile } from "redux/features/hostSlice/profile/hostProfileSlice";
import { judgeUuid } from "container/MyProfile/Components/constants";
import { JudgeProfile } from "container/Judge/Profile";

export default function ProtectedRoutes() {
  const dispatch = useDispatch();
  const setOriginalRole = useContext(OriginalRoleDisptachContext);
  const role = useContext(RoleContext);
  const setRole = useContext(RoleDispatchContext);

  const [initialRoute, setInitialRoute] = useState("/");
  const { data, loading, error, refetch } = useQuery(getMemberProfileQuery, {
    fetchPolicy: "no-cache",
  });
  const refresh = useSelector((state: any) => state?.global.refresh);
  const roleState = useSelector((state: any) => state?.auth.authReducer.role);

  const SetIntialRouteUsingRole = () => {
    if (role === ROLE.Member && !error) {
      setInitialRoute("/dashboard/memberDashboard");
    } else if (role === ROLE.Host) {
      setInitialRoute("/host/trailCalender");
    } else if (role === ROLE.SuperAdmin) {
      setInitialRoute("/admin/dashboard");
    } else if (role === ROLE.Judge) {
      setInitialRoute(`/${judgeUuid}/judgeProfile`);
    }
  };

  useEffect(() => {
    if (!loading && error) {
      setInitialRoute("/member/registerMember");
      setRole(ROLE.Member);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  useEffect(() => {
    if (!loading && data?.getMyMemberProfile) {
      const { role } = data.getMyMemberProfile;
      const currentRole = role?.includes("Super Admin")
        ? ROLE.SuperAdmin
        : role?.includes("Host")
        ? ROLE.Host
        : role?.includes("Member")
        ? ROLE.Member
        : role?.includes("Judge")
        ? ROLE.Judge
        : ROLE.Member;

      if (roleState === "") {
        setRole(currentRole);
      }
      setOriginalRole(currentRole);
      dispatch(setMemberDetails(data?.getMyMemberProfile));
      dispatch(setHostProfile(data?.getMyMemberProfile));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.getMyMemberProfile]);

  useEffect(() => {
    if (refresh) {
      dispatch(setRefresh());
      refetch().then(() => {
        setInitialRoute("/dashboard/memberDashboard");
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh]);

  useEffect(() => {
    if (role !== "") {
      SetIntialRouteUsingRole();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [role]);

  if (initialRoute === "/" || loading) {
    return <Loader />;
  }

  const ValidViews = () => {
    switch (role) {
      case ROLE.Member:
        return initialRoute === "/dashboard/memberDashboard" ? (
          <Routes>
            <Route path="/dashboard/*" element={<DashboardRoutes />} />
            <Route
              path="/"
              element={<Navigate to={"/dashboard/memberDashboard"} replace />}
            />
            <Route
              path="*"
              element={<Navigate to={"/dashboard/memberDashboard"} replace />}
            />
          </Routes>
        ) : (
          <Routes>
            <Route path="/member/*" element={<MemberRoutes />} />
            <Route
              path="/"
              element={<Navigate to={"/member/registerMember"} replace />}
            />
            <Route
              path="*"
              element={<Navigate to={"/member/registerMember"} replace />}
            />
          </Routes>
        );
      case ROLE.Host:
        return (
          <Routes>
            <Route path="/host/*" element={<HostRoutes />} />
            <Route
              path="/"
              element={<Navigate to={"/host/trialCalendar/"} replace />}
            />
            <Route
              path="*"
              element={<Navigate to={"/host/trialCalendar/"} replace />}
            />
          </Routes>
        );
      case ROLE.SuperAdmin:
        return (
          <Routes>
            <Route path="/admin/*" element={<SuperAdminRoutes />} />
            <Route
              path="/"
              element={<Navigate to={"/admin/dashboard"} replace />}
            />
            <Route
              path="*"
              element={<Navigate to={"/admin/dashboard"} replace />}
            />
          </Routes>
        );
      case ROLE.Judge:
        return (
          <Routes>
            <Route
              path={`/${judgeUuid}/*`}
              element={
                <Routes>
                  <Route path="/judgeProfile" element={<JudgeProfile />} />
                </Routes>
              }
            />
            <Route
              path="/"
              element={<Navigate to={`/${judgeUuid}/judgeProfile`} replace />}
            />
            <Route
              path="*"
              element={<Navigate to={`/${judgeUuid}/judgeProfile`} replace />}
            />
          </Routes>
        );
      default:
        return (
          <>
            <Loader />
          </>
        );
    }
  };

  return <BrowserRouter>{ValidViews()}</BrowserRouter>;
}
